import {
  HttpErrorResponse,
  HttpResponse as AngularHttpResponse,
} from '@angular/common/http';

export function saveBlobResponse(response: AngularHttpResponse<Blob>, fallbackFileName: string): void {
  const blob = response.body;
  if (!blob) {
    throw new Error('Файл пустой.');
  }

  const fileName = getFileNameFromContentDisposition(response.headers.get('content-disposition')) ?? fallbackFileName;
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function getDownloadErrorMessage(error: unknown, fallbackMessage: string): Promise<string> {
  if (error instanceof HttpErrorResponse) {
    const blobMessage = await readBlobErrorMessage(error.error);
    if (blobMessage) {
      return blobMessage;
    }

    if (typeof error.error?.errorMessage === 'string') {
      return error.error.errorMessage;
    }
    if (typeof error.error === 'string' && error.error.trim()) {
      return error.error.trim();
    }

    return fallbackMessage;
  }

  return error instanceof Error ? error.message : fallbackMessage;
}

function getFileNameFromContentDisposition(header: string | null): string | null {
  if (!header) {
    return null;
  }

  const encodedMatch = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (encodedMatch) {
    return decodeURIComponent(encodedMatch[1].trim());
  }

  const plainMatch = /filename="?([^";]+)"?/i.exec(header);
  return plainMatch ? plainMatch[1].trim() : null;
}

async function readBlobErrorMessage(value: unknown): Promise<string | null> {
  if (!(value instanceof Blob)) {
    return null;
  }

  const text = (await value.text()).trim();
  if (!text) {
    return null;
  }

  try {
    const parsed = JSON.parse(text) as { errorMessage?: unknown; message?: unknown };
    if (typeof parsed.errorMessage === 'string') {
      return parsed.errorMessage;
    }
    if (typeof parsed.message === 'string') {
      return parsed.message;
    }
  } catch {
    return text;
  }

  return text;
}
